import React from 'react';
import { motion } from 'framer-motion';
import { decorationServices } from '../../data/christmasLighting';
export function DecorationServicesSection() {
  return <section id="decorations" aria-labelledby="decorations-title" className="scroll-mt-32 bg-[#C62828] py-20 md:py-28" data-id="element-26" data-mp="15p0g85vc1igf">
      <div className="mx-auto max-w-7xl px-5 sm:px-8" data-id="element-27" data-mp="1fpar3jtwadsf">
        <div className="mx-auto max-w-2xl text-center" data-id="element-28" data-mp="1fnq0g5apbezu">
          <p className="inline-flex items-center gap-3 text-xs font-bold uppercase tracking-[0.22em] text-olive" data-id="element-29" data-mp="1tfmp1zd5v6rh">
            <span aria-hidden="true" className="h-px w-8 bg-current" data-id="element-30" data-mp="1ogb74n125v8b" />
            Christmas Decoration Services
            <span aria-hidden="true" className="h-px w-8 bg-current" data-id="element-31" data-mp="23e3hz1vntvg6" />
          </p>
          <h2 id="decorations-title" className="mt-5 font-display text-4xl font-medium leading-tight tracking-tight text-forest md:text-5xl" data-id="element-32" data-mp="1ygk1dvbhp6l2">
            Everything your property needs to <span className="italic text-[#9B2335]" data-id="element-33" data-mp="420z9tuv153k">shine</span>.
          </h2>
        </div>

        <ul className="mt-14 grid gap-6 sm:grid-cols-2 lg:grid-cols-3" data-id="element-34" data-mp="j7e4ujzit522">
          {decorationServices.map((service, index) => <motion.li key={service.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.5,
          delay: index % 3 * 0.08
        }} className="group overflow-hidden rounded-[1.75rem] bg-cream ring-1 ring-forest/[0.06] transition-shadow duration-500 hover:shadow-[0_24px_48px_-24px_rgba(38,58,41,0.45)]" data-id="element-35" data-mp="n993thtzb6co" data-mpi={index}>
              <div className="aspect-[4/3] overflow-hidden" data-id="element-36" data-mp="1axseg40i3v7x">
                <img src={service.image} alt={service.alt} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.05]" data-id="element-37" data-mp="1aw7jwee6sca2" />
              </div>
              <div className="p-6" data-id="element-38" data-mp="otht2eklpeog">
                <h3 className="flex items-center gap-2.5 font-display text-xl font-medium text-forest" data-id="element-39" data-mp="ouji5mygc1p6">
                  <span aria-hidden="true" className="h-2 w-2 rounded-full bg-[#9B2335]" data-id="element-40" data-mp="jwhoy97balzz" />
                  {service.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-forest/70" data-id="element-41" data-mp="svuzl5769gma">{service.description}</p>
              </div>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}